<script setup lang="ts">
import { computed, getCurrentInstance } from 'vue';
import type { IColumnDefinition, RowData } from '../types';

const props = defineProps<{
  value: any;
  row: RowData;
  column: IColumnDefinition;
}>();

const i18n = (getCurrentInstance()?.proxy as any)?.$app?.i18n;

const formattedDate = computed(() =>
  i18n ? i18n.formatDate(props.value) : props.value,
);
</script>

<template>
  <span class="text-nowrap">{{ formattedDate }}</span>
</template>
